import Nav from "../../components/home/Nav";
import SupportHint from "../../components/ui/SupportHint";
import "../../styles/error-pages.css";

const errorContent = {
  404: {
    code: "۴۰۴",
    title: "صفحه پیدا نشد",
    text: "آدرسی که وارد کرده‌اید در فروشگاه جوتی وجود ندارد یا جابه‌جا شده است.",
    action: "بازگشت به فروشگاه"
  },
  500: {
    code: "۵۰۰",
    title: "مشکلی پیش آمد",
    text: "در نمایش این بخش مشکلی رخ داده است. لطفاً چند لحظه بعد دوباره تلاش کنید.",
    action: "بازگشت به صفحه اصلی"
  }
};

const ErrorPage = ({ type = "404", showNav = true }) => {
  const content = errorContent[type] || errorContent["404"];

  return (
    <>
      {showNav && <Nav />}

      <main className="error-page">
        <section className="error-card">
          <span className="error-code">{content.code}</span>
          <h1>{content.title}</h1>
          <p>{content.text}</p>

          <div className="error-actions">
            <a href="/" className="error-primary-link">
              {content.action}
            </a>

            <a href="/products" className="error-ghost-link">
              مشاهده محصولات
            </a>
          </div>

          <SupportHint
            tone={type === "500" ? "error" : "warning"}
            text="اگر همچنان مشکل داشتید، با ما در ارتباط باشید."
          />
        </section>
      </main>
    </>
  );
};

export default ErrorPage;
